import { c as _c } from "react/compiler-runtime";
import React from "react";
import { Phone, Mail } from "lucide-react";
const ContactSection: React.FC = () => {
  const $ = _c(5);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="space-y-1"><h3 className="font-serif text-base lg:text-lg text-v2-primary font-semibold">Have a question? Need a bulk order?</h3><p className="text-xs lg:text-sm text-stone-500 font-normal">We’re here to help 8am to 10pm</p></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="w-8 h-8 rounded-full bg-v2-surface-container-high flex items-center justify-center text-v2-primary group-hover:bg-v2-primary group-hover:text-white transition-colors duration-200"><Phone className="w-4 h-4" /></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <a className="flex items-center gap-2 group transition-transform duration-200 hover:scale-[1.02]" href="tel:9108618389">{t1}<div className="text-left"><p className="text-[9px] font-label uppercase tracking-widest text-v2-on-surface-variant leading-none">Call / WhatsApp</p><p className="font-body text-xs font-semibold text-stone-600 mt-0.5">9108618389</p></div></a>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="w-8 h-8 rounded-full bg-v2-surface-container-high flex items-center justify-center text-v2-primary group-hover:bg-v2-primary group-hover:text-white transition-colors duration-200"><Mail className="w-4 h-4" /></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <section className="bg-v2-surface-container-low py-4 px-6 border border-v2-outline-variant/10 rounded-2xl w-full"><div className="flex flex-col items-center justify-center gap-4 text-center">{t0}<div className="flex items-center justify-center gap-8 w-full">{t2}<a className="flex items-center gap-2 group transition-transform duration-200 hover:scale-[1.02]" href="mailto:info@tooffi.com">{t3}<div className="text-left"><p className="text-[9px] font-label uppercase tracking-widest text-v2-on-surface-variant leading-none">E-mail Us</p><p className="font-body text-xs font-semibold text-stone-600 mt-0.5">info@tooffi.com</p></div></a></div></div></section>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
};
export default ContactSection;